export function sortUnscannedItems(items, mode, boxes, orderItemBoxes) {
  if (!Array.isArray(items) || mode !== 'packing') return items;

  const boxPositionById = {};
  (Array.isArray(boxes) ? boxes : []).forEach(box => {
    if (box) boxPositionById[box.id] = box.position;
  });

  const placementByItemId = {};
  (Array.isArray(orderItemBoxes) ? orderItemBoxes : []).forEach(oib => {
    if (oib && placementByItemId[oib.order_item_id] === undefined) {
      placementByItemId[oib.order_item_id] = {
        boxPos: boxPositionById[oib.box_id],
        itemPos: oib.position,
      };
    }
  });

  const placementOf = item => {
    const p = item ? placementByItemId[item.order_item_id] : undefined;
    return p && p.boxPos != null ? p : null;
  };

  return [...items].sort((a, b) => {
    const pa = placementOf(a);
    const pb = placementOf(b);
    if (!pa && !pb) return 0;
    if (!pa) return 1;
    if (!pb) return -1;
    if (pa.boxPos !== pb.boxPos) return pa.boxPos - pb.boxPos;
    return (pa.itemPos == null ? 0 : pa.itemPos) - (pb.itemPos == null ? 0 : pb.itemPos);
  });
}
